import React, { KeyboardEventHandler } from "react";
import getGuestPickerTranslations from "./translations";
import NumericStepper from "src/components/numericStepper";
import Icon from "src/components/icon";
import Accordion from "src/components/accordion";
import { getLanguageField } from "src/utils/language";

class GuestPickerLabel extends React.Component<{ text: string, description: string }> {
    render(): React.ReactNode {
        return <>
        <div className="grow shrink basis-0 self-stretch flex-col justify-center items-start gap-0.5 inline-flex">
            <div className="justify-start items-center gap-1 inline-flex">
                <div className="text-neutral-800 generalText">{this.props.text}</div>
                <div className="text-zinc-400 caption">{this.props.description}</div>
            </div>
        </div>
        </>
    }
}

type GuestPickerProps = {
    language: string;
    guests: TAgeCategory[];
    adults: number | undefined;
    children: number | undefined;
    ages?: number[] | undefined;
    placeholder?: string;
    setAdults: (adults: number) => void;
    setChilds: (childs: number, ages: number[]) => void;

    inputColor?: string;
    borderColor?: string;
    backgroundColor?: string;
}

//Only prepared to have junior and adults

export default class GuestPickerV2 extends React.Component<GuestPickerProps> {

    static defaultProps: Partial<GuestPickerProps> = {
        placeholder: "Guests",
    };

    private accordionRef = React.createRef<Accordion>();

    onKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
        if (e.nativeEvent.code === "Space" || e.nativeEvent.code === "Enter") {
            this.accordionRef.current?.open();
            e.preventDefault();
        }
    }

    get childages() {
        const childages = this.props.ages || [];
        const output: number[] = [];
        for (let index = 0; index < (this.props.children || 0); index++) output.push(childages[index] || 1);
        return output;
    }

    get inputLabel() {
        const translations = getGuestPickerTranslations(this.props.language);
        let label = "";
        if (this.props.adults || 0 > 0) label += `${this.props.adults} ${translations.adults}`;
        if (this.props.children || 0 > 0) label += `, ${this.props.children} ${translations.children}`;
        if (label === "") return translations.guests;
        return label;
    }

    get juniorWithAgeSelection(){
        return this.props.guests.some(guest => guest.type === "junior" && guest.age_selection)
    }

    get style(): any {
        return {
            '--background-color': this.props.backgroundColor || '#fff',
            '--border-color': this.props.borderColor || '#EAEAF2',
            '--input-color': this.props.inputColor || '',
        }
    }

    onGuestChange(guest: TAgeCategory, value: number, ages: number [] = []){
      if (guest.type === "adult") this.props.setAdults(value)
      if (guest.type === "junior") this.props.setChilds(value, ages)
    }

    getValue(guest: TAgeCategory){
      if (guest.type === "adult") return this.props.adults
      if (guest.type === "junior") return this.props.children
    }

    render() {
        const childages = this.childages;
        const translations = getGuestPickerTranslations(this.props.language);

    return <div className="relative" style={this.style}>
        <Accordion
            removeChildrenWhenClosed={true}
            ref={this.accordionRef}
            opener={
            <div role="button" aria-label={this.inputLabel} tabIndex={0} onKeyDown={this.onKeyDown} className="w-full h-10 px-4 py-3 text-[color:var(--input-color)] bg-[color:var(--background-color)] rounded-lg border border-[color:var(--border-color)] justify-start items-center gap-2.5 inline-flex focus:outline-none focus:ring-1 focus:ring focus:ring-blue-600">
                <div className="grow shrink basis-0 justify-between items-center flex">
                    <div className="caption">{this.inputLabel}</div>
                    <Icon icon="ChevronDown" className="w-4 h-4" />
                </div>
            </div>}
        >
        <div className="absolute translate-y-[-160px] lg:translate-y-0 lg:top-11 left-[50%] z-10 translate-x-[-161px] w-[322px] py-4 bg-white rounded-lg border border-slate-200 flex-col justify-center items-start gap-2 inline-flex shadow-lg">
            {this.props.guests.map((guest) => <div className="w-full justify-between items-center gap-2 flex flex-row px-4">
                <GuestPickerLabel
                  text={getLanguageField(guest.translations, this.props.language, "name") as string}
                  description={getLanguageField(guest.translations, this.props.language, "short_description") as string}
                />
                <NumericStepper
                  quantity={this.getValue(guest)}
                  min={guest.min_amount}
                  max={guest.max_amount}
                  layout="rounded"
                  onChange={(value: number)=> { this.onGuestChange(guest, value, this.props.ages || new Array(value)) }}
                  />
            </div> )}

            {/* Divider */}
            { this.juniorWithAgeSelection && (this.props.children || 0) > 0 ? <div className="h-[1px] bg-slate-200 w-full my-2"></div> : null }

            {/* Child Ages */}
            <div className="flex flex-col w-full max-h-[200px] overflow-y-auto gap-2">
            { this.juniorWithAgeSelection ? childages.map((age, index: number)=>
                <div key={`child-${index}`} className="w-full justify-between items-center gap-2 flex flex-row px-4">
                    <GuestPickerLabel text={`${translations.child} ${index + 1} ${translations.age}`} description="" />
                    <NumericStepper
                        quantity={age} min={1} max={12}
                        layout="rounded"
                        onChange={(value: number)=> {
                            childages[index] = value;
                            this.props.setChilds(this.props.children || 0, childages)
                        }}
                    />
                </div>
            ) : null }
            </div>

        </div>
        </Accordion>
    </div>
    }
}
